import styles from "./Layout.module.css";
import { Outlet } from "react-router";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import { useState, useEffect } from "react";
import { useIsMobile } from "../../hooks/useIsMobile";
import { Layout } from "antd";

const { Content } = Layout;

export default function Layouts() {
  const isMobile = useIsMobile();

  return (
    <Layout
      className={`${styles.mainLayouts} ${isMobile ? styles.mobileLayout : ""}`}
    >
      <Sidebar />
      <Layout className={styles.layout}>
        {!isMobile && <Header />}
        <Content className={styles.Content}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
